import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { Inject, inject, Injectable } from '@angular/core';



export const groupGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot): boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const allowedGroups = route.data['groups'] as string[];

  if (!authService.isInGroup(allowedGroups)) {
    router.navigate(['/access-denied']);
    return false;
  }

  return true;
};
